import firebase from 'firebase/app'


export const getDefaultData = (data = {}) => ({
  ...data,
  created_at: new Date(),
})


/**
 * Add a new Client
 * @param {ShopData} data - The data of  the shop
 * @returns {Shop} The shop object
 */
const addClient = async (data) => {
  const db = firebase.firestore()

  const doc = await db.collection('clients').add(getDefaultData(data))

  const snapshot = await db.collection('clients').doc(doc.id).get()
  const result = snapshot.data()

  return {
    ...result,
    id: snapshot.id,
    created_at: result.created_at.toDate(),
  }
}


export default addClient
